<div class="grid-container grid-1">
    @if ((tilesConfig?.hasTileAdminAccess$ | async) || (tiles && tiles.length > 0)) {
        <div class="flex-header no-print" [class.header-without-card]="config.headerWithoutCard">
            <span class="title word-wrap font-size-12em sse-titles-color">
                {{ config.translations.widgetTitle }}
            </span>
            <div>
                @if (!config.hideAddButton) {
                    <help-button class="no-print" [link]="helpButtonUrl" />
                }
                @if ((tilesConfig?.hasTileAdminAccess$ | async) && !config.hideAddButton) {
                    <ui-icon-button
                        iconName="create"
                        class="no-print"
                        [advizeoTooltip]="'WIDGET.HOME_TILES.ADD' | translate"
                        (click)="goToNewTile()"
                    />
                }
            </div>
        </div>
    }
    <div class="masonry">
        @for (tile of tiles; track tile; let i = $index) {
            <tile-spawner
                class="masonry-item print-do-not-break masonry_item_{{ tile.tileType | lowercase }}"
                [tileData]="tile"
                [tileConfig]="tilesConfig"
                (deleted)="deleteTile(i)"
            />
        }
    </div>
</div>
